(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd24-bento-features"] && !Shopify.designMode) return;
  try {
    
(function(){
  function atc(){return document.querySelector('.main-product-atc, [name="add"]');}
  document.querySelectorAll('a.nd24-bento__cta[data-nd24-rollup]').forEach(function(a){
    a.addEventListener('click',function(e){
      var el=atc();
      if(el){ e.preventDefault(); el.scrollIntoView({behavior:'smooth',block:'center'}); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd24-camping-section"] && !Shopify.designMode) return;
  try {
    
(function(){
  function atc(){return document.querySelector('.main-product-atc, [name="add"]');}
  document.querySelectorAll('a.nd24-camp__btn[data-nd24-rollup]').forEach(function(a){
    a.addEventListener('click',function(e){
      var el=atc();
      if(el){ e.preventDefault(); el.scrollIntoView({behavior:'smooth',block:'center'}); }
    });
  });

  // PAGESPEED 2026-08-16: Video erst laden, wenn der Abschnitt in die Naehe des
  // Sichtfensters kommt. Bis dahin steht nur das Vorschaubild (poster).
  var videos = document.querySelectorAll('video[data-nd24-lazyvideo]');
  if (!videos.length) return;

  function laden(video){
    if (video.dataset.nd24Geladen) return;
    video.dataset.nd24Geladen = '1';
    var quelle = document.createElement('source');
    quelle.src = video.dataset.src;
    quelle.type = 'video/mp4';
    video.appendChild(quelle);
    video.load();
    if (video.dataset.autoplay) {
      var p = video.play();
      // Browser koennen Autoplay verweigern; dann bleibt schlicht das Posterbild.
      if (p && p.catch) p.catch(function(){});
    }
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(laden);
    return;
  }

  // Erst nach dem Laden der Seite beobachten. Sonst startet das Video auf der
  // Startseite sofort mit - der Abschnitt liegt dort knapp unter der Falz - und
  // konkurriert mit dem Hero-Bild um Bandbreite (LCP).
  function beobachtungStarten(){
    var beobachter = new IntersectionObserver(function(eintraege){
      eintraege.forEach(function(e){
        if (!e.isIntersecting) return;
        laden(e.target);
        beobachter.unobserve(e.target);
      });
    // rootMargin 0: erst laden, wenn der Abschnitt wirklich im Sichtfenster steht.
    // Mit Vorlauf (200px) lag er auf der Startseite schon beim Laden im Bereich und
    // die 4 MB wurden trotz Verzoegerung immer geholt - auch von Besuchern, die nie
    // so weit scrollen. Bis dahin steht das Posterbild.
    }, { rootMargin: '0px' });
    videos.forEach(function(v){ beobachter.observe(v); });
  }

  if (document.readyState === 'complete') {
    beobachtungStarten();
  } else {
    window.addEventListener('load', beobachtungStarten);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd24-reviews-2"] && !Shopify.designMode) return;
  try {
    
(function(){document.querySelectorAll('.nd24-rv2__track').forEach(function(t){var p=function(){t.style.animationPlayState='paused';},r=function(){t.style.animationPlayState='';};t.addEventListener('touchstart',p,{passive:true});t.addEventListener('touchmove',p,{passive:true});t.addEventListener('touchend',r,{passive:true});t.addEventListener('touchcancel',r,{passive:true});t.addEventListener('mouseenter',p);t.addEventListener('mouseleave',r);});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd24-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){document.querySelectorAll('.nd24-rv__track').forEach(function(t){var p=function(){t.style.animationPlayState='paused';},r=function(){t.style.animationPlayState='';};t.addEventListener('touchstart',p,{passive:true});t.addEventListener('touchmove',p,{passive:true});t.addEventListener('touchend',r,{passive:true});t.addEventListener('touchcancel',r,{passive:true});t.addEventListener('mouseenter',p);t.addEventListener('mouseleave',r);});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nd24-trucker-section"] && !Shopify.designMode) return;
  try {
    
(function(){
  function atc(){return document.querySelector('.main-product-atc, [name="add"]');}
  document.querySelectorAll('a.nd24-truck__btn[data-nd24-rollup]').forEach(function(a){
    a.addEventListener('click',function(e){
      var el=atc();
      if(el){ e.preventDefault(); el.scrollIntoView({behavior:'smooth',block:'center'}); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
